import React, { useEffect } from 'react';
import { initFbPixel, trackPageView } from './utils/fbpixel';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { WhyItFailedSection } from './components/WhyItFailedSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { WhoIsItForSection } from './components/WhoIsItForSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  useEffect(() => {
    initFbPixel('1348863570412843');
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage selection:text-cream" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <WhyItFailedSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <WhatYouGetSection data-id="element-6" />
        <WhoIsItForSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProofSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>
      <FooterSection data-id="element-12" />
    </div>;
}